export const WeekDayMap = {
  Monday: 'monday',
  Tuesday: 'tuesday',
  Wednesday: 'wednesday',
  Thursday: 'thursday',
  Friday: 'friday',
  Saturday: 'saturday',
  Sunday: 'sunday',
} as const

export const WeekDayKoreanMap = {
  Monday: '월',
  Tuesday: '화',
  Wednesday: '수',
  Thursday: '목',
  Friday: '금',
  Saturday: '토',
  Sunday: '일',
} as const

export const BankMap: { [key: string]: string } = {
  '01': '한국은행',
  '02': '한국산업은행',
  '03': '중소기업은행',
  '04': 'KB국민은행',
  '05': '하나은행',
  '06': 'KB국민은행',
  '07': '수협은행',
  '08': '한국수출입은행',
  '09': '수협은행',
  '10': 'NH농협은행',
  '11': 'NH농협은행',
  '12': '지역농·축협',
  '13': '지역농·축협',
  '14': '지역농·축협',
  '15': '지역농·축협',
  '16': 'NH농협은행',
  '17': '지역농·축협',
  '18': '지역농·축협',
  '19': 'KB국민은행',
  '20': '우리은행',
  '21': '신한은행',
  '22': '우리은행',
  '23': 'SC제일은행',
  '25': '하나은행',
  '26': '신한은행',
  '27': '한국씨티은행',
  '28': '신한은행',
  '29': 'KB국민은행',
  '31': 'DGB대구은행',
  '32': 'BNK부산은행',
  '33': '하나은행',
  '34': '광주은행',
  '35': '제주은행',
  '36': '한국씨티은행',
  '37': '전북은행',
  '39': 'BNK경남은행',
  '43': '중소기업은행',
  '45': '새마을금고',
  '46': '새마을금고',
  '47': '신용협동조합',
  '48': '신용협동조합',
  '49': '신용협동조합',
  '50': '상호저축은행',
  '53': '한국씨티은행',
  '64': '산림조합',
  '71': '우체국예금',
  '72': '우체국예금',
  '73': '우체국예금',
  '74': '우체국예금',
  '75': '우체국예금',
  '78': 'KB국민은행',
  '79': 'KB국민은행',
  '80': '하나은행',
  '81': '하나은행',
  '82': '하나은행',
  '83': '우리은행',
  '84': '우리은행',
  '85': '새마을금고',
  '86': '새마을금고',
  '87': '새마을금고',
  '88': '신한은행',
  '89': '케이뱅크',
  '90': '카카오뱅크',
  '92': '토스뱅크',
}

// 금감원 코드 이용한 은행명 맵핑
export const BANK_FSS_CODE_MAP: { [key: string]: string } = {
  '039': '경남은행',
  '034': '광주은행',
  '012': '단위농협(지역농축협)',
  '032': '부산은행',
  '045': '새마을금고',
  '064': '산림조합',
  '088': '신한은행',
  '048': '신협',
  '027': '씨티은행',
  '020': '우리은행',
  '071': '우체국예금보험',
  '050': '저축은행중앙회',
  '037': '전북은행',
  '035': '제주은행',
  '090': '카카오뱅크',
  '089': '케이뱅크',
  '092': '토스뱅크',
  '081': '하나은행',
  '054': '홍콩상하이은행',
  '003': 'IBK기업은행',
  '004': 'KB국민은행',
  '031': 'DGB대구은행',
  '002': 'KDB산업은행',
  '011': 'NH농협은행',
  '023': 'SC제일은행',
  '007': 'Sh수협은행',
}

export const CARD_FSS_CODE_MAP: { [key: string]: string } = {
  '3K': '기업 BC',
  '46': '광주은행',
  '71': '롯데카드',
  '30': 'KDB산업은행',
  '31': 'BC카드',
  '51': '삼성카드',
  '38': '새마을금고',
  '41': '신한카드',
  '62': '신협',
  '36': '씨티카드',
  '33': '우리BC카드(BC 매입)',
  W1: '우리카드(우리 매입)',
  '37': '우체국예금보험',
  '39': '저축은행중앙회',
  '35': '전북은행',
  '42': '제주은행',
  '15': '카카오뱅크',
  '3A': '케이뱅크',
  '24': '토스뱅크',
  '21': '하나카드',
  '61': '현대카드',
  '11': 'KB국민카드',
  '91': 'NH농협카드',
  '34': 'Sh수협은행',
}
